/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Dropdown.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-500.js"
import ButtonIconOutline from 'DesignSystem/ButtonIconOutline/view.js'
import DropdownButton from 'DesignSystem/DropdownButton/view.js'
import DropdownFilter from 'DesignSystem/DropdownFilter/logic.js'
import DropdownOptions from 'DesignSystem/DropdownOptions/view.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import SelectAll from 'DesignSystem/Svgs/SelectAll/view.js'
import Warning from 'DesignSystem/Svgs/Warning/view.js'
import { css } from "emotion"
DropdownFilter.displayName = 'DropdownFilterLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  overflowY: "visible",
overflowX: "visible",
  marginLeft: 'var(--marginLeft)',
marginRight: 'var(--marginRight)',
marginTop: 'var(--marginTop)',
marginBottom: 'var(--marginBottom)'})
styles.Text = css({label: 'Text',
  color: "#606060",
fontFamily: "WonderUnitSans",
fontSize: 8,
fontWeight: 500,
letterSpacing: 1,
textTransform: "uppercase",
  marginBottom: 'var(--marginBottom)',
marginLeft: 'var(--marginLeft)'})
styles.Vertical1 = css({label: 'Vertical1',
  position: "absolute",
top: 3,
right: 4,
zIndex: 1000})
styles.Vertical2 = css({label: 'Vertical2',
  borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
justifyContent: "center",
alignItems: "center",
backgroundColor: "rgba(255,182,0,0.3)",
marginBottom: 7,
marginLeft: 8,
width: 22,
height: 22,
position: "absolute",
right: 27,
top: 5})

export default function Dropdown({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  marginLeft= 0,
marginRight= 0,
marginTop= 0,
marginBottom= 0,
label= "",
marginBottomLabel= 8,
disabled,
hasMany,
value,
marginTopInfo= 0,
dropdownRef,
isMultiChoice,
onClickToggleSelectAll,
hasSelectedAll,
isFilterable,
isInvalid,
minWidth,
onBlur,
onChangeFilter,
onKeyDown,
onClickShow,
onCopy,
onPaste,
placeholder,
heightButton,
valueWidth,
paddingBottom,
paddingLeft,
paddingRight,
paddingTop,
fontSize,
borderBottomLeftRadius= 5,
borderBottomRightRadius= 5,
borderTopLeftRadius= 5,
borderTopRightRadius= 5,
isShowing,
alignItems= "flex-start",
toggleIsShowing,
isShowingWarning,
field= "text",
from,
onClick,
isSelected,
height= 225,
width,
top= 32,
right,
left,
transformOriginY,
isHovered
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="Dropdown.Vertical"
 data-view-path={dataViewPath}
 style={{'--marginLeft': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--marginRight': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--marginTop': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--marginBottom': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom}}
 className={`views-block ${styles.Vertical}`}
>
{
label ? 
<span
 data-testid="Dropdown.Text"
 data-view-path={dataViewPath}
 style={{'--marginBottom': typeof marginBottomLabel === 'number' ? `${marginBottomLabel}px` : marginBottomLabel,'--marginLeft': disabled ? "0px" : "10px"}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
 : null
}
{
!hasMany ? 
<Info
 data-testid="Dropdown.Info"
 data-view-path={dataViewPath}
 text={value}
 marginLeft={10}
 marginTop={marginTopInfo}
/>
 : null
}
{
hasMany ? 
<div
 data-testid="Dropdown.Vertical:1"
 data-view-path={dataViewPath}
 ref={dropdownRef}
 className="views-block"
>
{
isMultiChoice ? 
<div
 data-testid="Dropdown.Vertical:2"
 data-view-path={dataViewPath}
 className={`views-block ${styles.Vertical1}`}
>
<ButtonIconOutline
 data-testid="Dropdown.ButtonIconOutline"
 data-view-path={dataViewPath}
 onClick={onClickToggleSelectAll}
 backgroundColor={hasSelectedAll ? "rgba(0,162,255,0.2)" : "transparent"}
>
{childProps => (
<SelectAll
{...childProps}
 data-testid="Dropdown.SelectAll"
 data-view-path={dataViewPath}
 width={15}
 height={22}
 stroke={childProps.isHovered ? "rgb(0,162,255)" : hasSelectedAll ? "rgb(0,162,255)" : "#606060"}
/>
)}
</ButtonIconOutline>
</div>
 : null
}
{
isFilterable ? 
<DropdownFilter
 data-testid="Dropdown.DropdownFilter"
 data-view-path={dataViewPath}
 backgroundColor={isShowing ? "#f2f2f2" : disabled ? "transparent" : "#f2f2f2"}
 disabled={disabled}
 isInvalid={isInvalid}
 isMultiChoice={isMultiChoice}
 minWidth={minWidth}
 onBlur={onBlur}
 onChangeFilter={onChangeFilter}
 onKeyDown={onKeyDown}
 onClickShow={onClickShow}
 onCopy={onCopy}
 onPaste={onPaste}
 placeholder={placeholder}
 height={heightButton}
 value={value}
 valueWidth={valueWidth}
 paddingBottom={paddingBottom}
 paddingLeft={paddingLeft}
 paddingRight={paddingRight}
 paddingTop={paddingTop}
 fontSize={fontSize}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
/>
 : null
}
{
!isFilterable ? 
<DropdownButton
 data-testid="Dropdown.DropdownButton"
 data-view-path={dataViewPath}
 alignItems={alignItems}
 backgroundColor={isShowing ? "#f2f2f2" : disabled ? "transparent" : "#f2f2f2"}
 disabled={disabled}
 height={heightButton}
 isInvalid={isInvalid}
 isMultiChoice={isMultiChoice}
 minWidth={minWidth}
 onClick={toggleIsShowing}
 text={value}
 valueWidth={valueWidth}
/>
 : null
}
{
isShowingWarning ? 
<div
 data-testid="Dropdown.Vertical:3"
 data-view-path={dataViewPath}
 className={`views-block ${styles.Vertical2}`}
>
<Warning
 data-testid="Dropdown.Warning"
 data-view-path={dataViewPath}
 stroke="#ff6f00"
/>
</div>
 : null
}
{
isShowing ? 
<DropdownOptions
 data-testid="Dropdown.DropdownOptions"
 data-view-path={dataViewPath}
 field={field}
 from={from}
 onClick={onClick}
 isSelected={isSelected}
 height={height}
 width={width}
 top={top}
 right={right}
 left={left}
 transformOriginY={transformOriginY}
 isMultiChoice={isMultiChoice}
/>
 : null
}
</div>
 : null
}
</div>
{children}
</React.Fragment>)
}